import DescriptionAndPolicies from './DescriptionAndPolicies';
import ShortPolicies from './ShortPolicies';

export { DescriptionAndPolicies, ShortPolicies };
